module.exports = __webpack_public_path__ + "img/userLandingimg2.bd648434.webp";